import React, { useState, useEffect, useContext} from "react";
import Context from "../../../context/context";
import Swal  from "sweetalert2";
import Modal from "react-modal";
import Web3 from "web3";
import UFOpTGCContract from '../abi/Ptgc.json';
import UFOHEXContract from '../abi/Hex.json';
import UFOHEXETHContract from '../abi/HexEth.json';
import UFOINCContract from '../abi/Inc.json';
import UFOPLSXContract from '../abi/Plsx.json';
import UFOPLSContract from '../abi/Pls.json';
import UFODAIContract from '../abi/Dai.json';
import UFOContract from '../abi/Ufo.json';
import StakingContract from '../abi/Staking.json';
import ERC20Contract from '../abi/Erc20.json';
import { formatUnits, parseUnits } from "ethers";
import { providerURL, txAfterDone, txDone, txStart } from '../../../helper/Helper';

const RemoveLiquidityModal = ({ modalIsOpen, closeModal, pair, updatePage}) => {
  const {account, providers} = useContext(Context);
  const [pairAddrees, setPairAddrees] = useState(0);
  const [pairBalance, setPairBalance] = useState(0);
  const [pairSupply, setPairSupply] = useState(0);
  const [token0Name, setToken0Name] = useState('pTGC');
  const [token1Name, setToken1Name] = useState('UFO');
  const [token0Share, setToken0Share] = useState(0);
  const [token1Share, setToken1Share] = useState(0);
  const [amountToRemove, setAmountToRemove] = useState('');
  const [LPApproval, setLPApproval] = useState(0);

  useEffect(() => {
      if(amountToRemove > pairBalance)
      {
        setAmountToRemove(toFixed(Number(pairBalance), 2));
      }
      else
      {
        setAmountToRemove(toFixed(Number(amountToRemove),2));
      }
  }, [amountToRemove]);

  const handleModalOpen = async () => {
    await getData();
  };

  const getData = async () => {
      const web3 = await new Web3(providers);

      const newPair = pair.split("_");
      setToken0Name(newPair[1]);
      setToken1Name(newPair[0]);
      setAmountToRemove('');

      let pairInstance;
      let pairAddress;
      if (pair === "UFO_PTGC") {
          pairInstance = await new web3.eth.Contract(UFOpTGCContract.ABI, UFOpTGCContract.Contract);
          setPairAddrees(UFOpTGCContract.Contract);
      } else if (pair === "UFO_HEX") {
          pairInstance = await new web3.eth.Contract(UFOHEXContract.ABI, UFOHEXContract.Contract);
          setPairAddrees(UFOHEXContract.Contract);
      } else if (pair === "UFO_HEXETH") {
          pairInstance = await new web3.eth.Contract(UFOHEXETHContract.ABI, UFOHEXETHContract.Contract);
          setPairAddrees(UFOHEXETHContract.Contract);
      } else if (pair === "UFO_INC") {
          pairInstance = await new web3.eth.Contract(UFOINCContract.ABI, UFOINCContract.Contract);
          setPairAddrees(UFOINCContract.Contract);
      } else if (pair === "UFO_PLSX") {
          pairInstance = await new web3.eth.Contract(UFOPLSXContract.ABI, UFOPLSXContract.Contract);
          setPairAddrees(UFOPLSXContract.Contract);
      } else if (pair === "UFO_PLS") {
          pairInstance = await new web3.eth.Contract(UFOPLSContract.ABI, UFOPLSContract.Contract);
          setPairAddrees(UFOPLSContract.Contract);
      } else {
          pairInstance = await new web3.eth.Contract(UFODAIContract.ABI, UFODAIContract.Contract);
          setPairAddrees(UFODAIContract.Contract);
      }

      setPairSupply(Number(formatUnits(await pairInstance.methods.totalSupply().call(), 18)));
      setPairBalance(Number(formatUnits(await pairInstance.methods.balanceOf(account).call(), 18)));
      
      let token0 = await pairInstance.methods.token0().call();
      let token1 = await pairInstance.methods.token1().call();

      let pairShare = await pairInstance.methods.getReserves().call();
      if (pair === "UFO_HEX" || pair === "UFO_HEXETH") {
          if (token0 === UFOContract.Contract) {
              setToken0Share(Number(formatUnits(pairShare._reserve1, 8)));
              setToken1Share(Number(formatUnits(pairShare._reserve0, 18)));
          } else {
              setToken0Share(Number(formatUnits(pairShare._reserve0, 8)));
              setToken1Share(Number(formatUnits(pairShare._reserve1, 18)));
          }
      } else {
          if (token0 === UFOContract.Contract) {
              setToken0Share(Number(formatUnits(pairShare._reserve1, 18)));
              setToken1Share(Number(formatUnits(pairShare._reserve0, 18)));
          } else {
              setToken0Share(Number(formatUnits(pairShare._reserve0, 18)));
              setToken1Share(Number(formatUnits(pairShare._reserve1, 18)));
          }
      }
      if (token0 === UFOContract.Contract) {
          token0 = await pairInstance.methods.token1().call();
          token1 = await pairInstance.methods.token0().call();
      }
      await setLPApproval(Number(formatUnits(await pairInstance.methods.allowance(account, UFOContract.Contract).call(), 18)));
  }

  const approveLiquidity = async () => {
      const web3 = await new Web3(providers);
      const LPInstance = new web3.eth.Contract(ERC20Contract.ABI, pairAddrees);
      const amount = parseUnits(String(amountToRemove || "0"), 18);

      try {
          await LPInstance.methods.approve(UFOContract.Contract, amount).send({
              from: account
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                title: "Error Found",
                text: error.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Close",
                customClass: {
                  confirmButton: "btn-danger"
                }
              });
          }).then(function(receipt) {
              txDone()
              setTimeout(() => {
                txAfterDone()
              }, 2000)
              removeLiquidity();
          });
      } catch (error) {
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
        });
      }
  }

  const removeLiquidity = async () => {
      const web3 = await new Web3(providers);
      const UFOInstance = new web3.eth.Contract(UFOContract.ABI, UFOContract.Contract);
      const amount = parseUnits(String(amountToRemove || "0"), 18);
      
      try {
          if (pair === "UFO_PLS") {
              await UFOInstance.methods.removeLiquidityETH(pairAddrees, amount).send({
                  from: account
              }).on('transactionHash', function(payload) {
                  closeModal();
                  txStart();
              }).on('error', function(error) {
                  Swal.fire({
                    title: "Error Found",
                    text: error.message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonText: "Close",
                    customClass: {
                      confirmButton: "btn-danger"
                    }
                  });
              }).then(function(receipt) {
                  txDone()
                  setTimeout(() => {
                    txAfterDone()
                  }, 2000)
                  updatePage()
              });
          } else {
              await UFOInstance.methods.removeLiquidity(pairAddrees, amount).send({
                  from: account
              }).on('transactionHash', function(payload) {
                  closeModal();
                  txStart();
              }).on('error', function(error) {
                  Swal.fire({
                    title: "Error Found",
                    text: error.message,
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonText: "Close",
                    customClass: {
                      confirmButton: "btn-danger"
                    }
                  });
              }).then(function(receipt) {
                  txDone()
                  setTimeout(() => {
                    txAfterDone()
                  }, 2000)
                  updatePage()
              });
          }
      } catch (error) {
        txDone()
        txAfterDone()
        Swal.fire({
          title: "Error Found",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Close",
          customClass: {
            confirmButton: "btn-danger"
          }
        });
      }
  }

  function toPlainString(num) {
    return (''+ +num).replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/,
      function(a,b,c,d,e) {
        return e < 0
          ? b + '0.' + Array(1-e-c.length).join(0) + c + d
          : b + c + d + Array(e-d.length+1).join(0);
      });
  }

  function toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  }
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="UFOSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="good_times goldFont mb-0 mt-2  w-100">Remove Liquidity</h2>
            </div>

              <div className="row justify-content-center mt-4">
                <div className="col-sm-8 col-md-6 col-lg-6">
                  <div className="">
                  <div className="bSRIN overHide p-3 px-3">
                  <div className="bSRIN overHide mt-0 w-5100" style={{ border: '0px', borderRadius:'0px', borderBottom: '1px solid #383835' }}>
                    <div className="amountSTaking inputBGCOin d-flex1 justify-content-between align-items-center gap-3 mt-0" >
                      <div className="d-flex gap-2 w-100">
                        <div className="someBtns  perVal ">
                          <button className=" per border0 p-2 radius50"><span>PLP</span></button>
                        </div>
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder="Please enter amount"
                          value={
                            amountToRemove === "" || isNaN(Number(amountToRemove.toString().replace(/,/g, "")))
                              ? ""
                              : Number(amountToRemove.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                })
                          }
                          onChange={async (e) => {
                            let raw = e.target.value.replace(/,/g, "");

                            if (raw === "") {
                              await setAmountToRemove("");
                              return;
                            }

                            if (!/^\d*(\.\d{0,2})?$/.test(raw)) return;

                            let num = parseFloat(raw);
                            if (!isNaN(num) && num > pairBalance) {
                              raw = pairBalance.toString();
                            }
                            await setAmountToRemove(raw);
                          }}
                        />
                      </div>
                    </div>
                      <div className="someBtns d-flex gap-2 mt-3 modnoCOlo">
                        <button className="someSnbtn w-100" onClick={() => {setAmountToRemove((pairBalance * 25) / 100)}}><span>25%</span></button>
                        <button className="someSnbtn w-100" onClick={() => {setAmountToRemove((pairBalance * 50) / 100)}}><span>50%</span></button>
                        <button className="someSnbtn w-100" onClick={() => {setAmountToRemove((pairBalance * 75) / 100)}}><span>75%</span></button>
                        <button className="someSnbtn w-100" onClick={() => {setAmountToRemove(pairBalance)}}><span>100%</span></button>
                      </div>
                  <div className="iconiconSR text-center m-auto mt-3 mb-3 "><i className="fa-solid fa-arrow-down"></i></div>
                  <div className="mt-2 ">
                    <span className="fInter text-center w-100 d-block">You Will Receive</span>
                    <div className=" mt-2" style={{borderTop: '1px solid #383835'}}>
                      <div className="row ">
                        <div className="col-md-6 borderRight">
                          <div className="snPortal">
                            <div className="">
                              <div className="d-flex ">
                                <div className="sntokenSelect align-items-center d-flex w-auto">
                                  <img className="img-fluid" src={"./images/"+token1Name+".png"} />
                                  <span>{token1Name}</span>
                                </div>
                              </div>
                              <h3 className="dollorValue value  mt-2 p-0">
                                <span className="val">{pairSupply > 0 ? parseFloat((((amountToRemove / pairSupply) * 100) * token1Share) / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2}) : '0.00'}</span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 ">
                          <div className="snPortal">
                            <div className="">
                              <div className="d-flex ">
                                <div className="sntokenSelect align-items-center d-flex w-auto">
                                  <img className="img-fluid" src={"./images/"+token0Name+".png"}/>
                                  <span>{token0Name}</span>
                                </div>
                              </div>
                              <h3 className="dollorValue value mt-2 p-0">
                                <span className="val">{pairSupply > 0 ? parseFloat((((amountToRemove / pairSupply) * 100) * token0Share) / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2}) : '0.00'}</span>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row stakeSec" style={{borderTop: '1px solid #383835'}}>
                      <div className="col-md-6 borderRight">
                        <div className="p-3"><span className="perVal d-block">1 {token0Name} </span>
                          <h3 className="dollorValue value dollorValRight mt-0 ">
                              <span className="val">{token0Share > 0 ? parseFloat(token1Share / token0Share).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2}) : '0.00'}</span>
                              <span className="dollor dollor2">{token1Name}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-md-6 ">
                        <div className="p-3"><span className="perVal d-block">1 {token1Name} </span>
                          <h3 className="dollorValue value dollorValRight mt-0 ">
                            <span className="val">{token1Share > 0 ? parseFloat(token0Share / token1Share).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits:2}) : '0.00'}</span>
                            <span className="dollor dollor2">{token0Name}</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="someBtns SRTOP  d-flex gap-2 mt-2 p-2">
                    {
                       Number(amountToRemove) > Number(LPApproval) ?
                       <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" onClick={() => {approveLiquidity()}}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Approve PLP <div className="iconSR"><img className="img-fluid" src="./images/MinusCircle.svg" /></div></span>
                        </button>
                       </>
                       :
                       <>
                        <button className="someSnbtn d-flex align-items-center w-100 justify-content-between" onClick={() => {removeLiquidity()}} disabled={amountToRemove > 0 ? '' : 'disabled'}>
                          <span className="d-flex align-items-center w-100 justify-content-between">Remove Liquidity <div className="iconSR"><img className="img-fluid" src="./images/MinusCircle.svg" /></div></span>
                        </button>
                       </>
                    }
                  </div>
                  {
                    pairSupply > 0 && pairBalance > 0 ?
                    <>
                      <div className="subcontent SRTOP p-3 mt-3">
                      <div className="relative">
                        <div className=" d-flex align-items-center justify-content-between flex-wrap gap-1">
                          <h2 className="speacialH2 d-flex align-items-center">
                            <span className="d-flex bothCoins">
                              <img className="img-fluid" src={"./images/"+token1Name+".png"}/>
                              <img className="img-fluid" src={"./images/"+token0Name+".png"}/>
                            </span>
                            {token0Name} / {token1Name}
                          </h2>
                          <h2 className="speacialH2">
                            {parseFloat(pairBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} PLP
                          </h2>
                        </div>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Your Pool Share</span>
                        <p className="m-0">
                          <span className="">{parseFloat((pairBalance / pairSupply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%</span>
                        </p>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Pooled {token0Name}</span>
                        <p className="m-0">
                          <span className="">{parseFloat((((pairBalance / pairSupply) * 100) * token0Share) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </p>
                      </div>
                      <div className="mt-2 px-2 d-flex align-items-center justify-content-between flex-wrap">
                        <span className="perVal d-block">Pooled {token1Name}</span>
                        <p className="m-0">
                          <span className="">{parseFloat((((pairBalance / pairSupply) * 100) * token1Share) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </p>
                      </div>
                    </div>
                    </>
                    :
                    <>
                    </>
                  }
                 </div>
                </div>
              </div>
            </div>
        </div>
       </div>
     </div>
    </Modal>
    </>
  );
};

export default RemoveLiquidityModal;